import { useOrderAdjustmentsReportListFilterFields } from 'pages/OrderAdjustmentsReport/hooks/useOrderAdjustmentsReportListFilterFields';
import { DateRangePickerValue } from 'shared/mui/DatePicker/DateRangePicker/DateRangePicker';
import { FilterFields } from 'shared/mui/Filter/FilterFields/FilterFields';

export type OrderAdjustmentsReportListFilterFormValues = {
  appliedDate: [DateRangePickerValue, DateRangePickerValue];
  adjustmentType: string[];
  impactToBalance: '1' | '0' | null;
  requestId: string | null;
  adjustmentStatus: string[];
  user: string[];
};

export const OrderAdjustmentsReportListFilter: React.FC = () => {
  const fields = useOrderAdjustmentsReportListFilterFields();

  return <FilterFields fields={fields} />;
};
